export const languagesettings = {
  'languagesettings.title': 'Nastavitve jezika',
  'languagesettings.titleLanguage': 'JEZIK',
  'languagesettings.descriptionLanguage':
    'Povejte nam, kateri jezik želite uporabljati na Preferenci. Jezik lahko kadarkoli spremenite.',
  'languagesettings.titleContentLanguage': 'JEZIK VSEBIN',
  'languagesettings.descriptionContentLanguage':
    'Izberite jezik v katerega želite, da se prevede vsebina na Preferenci. Prikazali vam bomo možnosti za prevod vsebine kot so opisi in druge uporabniške vsebine v ta jezik in uporabili to informacijo za izboljšanje uporabniške izkušnje na Preferenci..',
}
